import axios from 'axios'
import router from '../router'
import store from '../store'
import { MessageBox } from 'element-ui'
import { itemscollection, activecollection, renewitems, renewcollection, chartdataxy, chartdatagroup } from "@/components/utility/indexdb";
import { hrefinfotostore, generateurl, tomakeurl } from './objparamobj'


function appinitial() {
    return new Promise((resolve, reject) => {
        //验证访问身份
        let verification = {}
        //如果无user那么按照visitor访问
        if (!store.state.user) {
            verification = { name: "visitor" }
        }
        //否则验证用户
        else {
            verification = { name: store.state.user }
        }
        //进行验证
        axios.dologin(verification).then((tell) => {

            if (tell === "failed") {
                console.log("login failed")
                localStorage.clear();
                itemscollection.remove({});
                router.push("/login");
                resolve("failed")
                return
            }
            if (tell === "relogin") {
                MessageBox({
                    // this.$message("账号在别处登录Account logged in elsewhere")
                    title: '账号在别处登录',
                    message: 'Account logged in elsewhere,please relogin',
                    callback: () => {

                    }
                })

                console.log("to relogin")
                localStorage.clear();
                itemscollection.remove({});
                router.push("/login");
                resolve("failed")
                return

            }

            //后台验证后返回相应数据库(collections)
            axios.getcollections()
                .then(() => {
                    let originalhref=window.location.href
                    searchfromurl(window.location.href)
                    .then(
                        //appinitial的特殊之处在于href的设置，可以手动编辑href后保存到savelist，这非常重要，可以手动编辑哪些params记入href中
                        //使用：手动编辑href后，将其searchsave，其他的搜索信息在store中获取
                        window.location.href=originalhref
                    )
                })


        })


    })
}

function searchfromurl(href) {
    return new Promise(resolve => {

        //将href信息存入store
        hrefinfotostore(href)

        //根据新设置的值设置collection权限

        axios.clctinitial.authset(store.state.collection)

        //通过store中的数据fetchdata
        axios.fetchdata()
            .then(() => {
                //通过url search的都进行initial
                axios.clctinitial.toinitiate(store.state.collection)
                resolve("done")
            })
    })
}






// function initialdata() {
//     return new Promise(resolve => {
//         //初始化items
//         renewitems();
//         //初始化图表数据
//         chartdataxy(store.state.xfield, store.state.yvalues).then(
//             doc => {
//                 chartdatagroup(
//                     store.state.xfield,
//                     store.state.yvalues,
//                     doc
//                 )
//                     .then(resolve("datainitiated"))
//             }
//         );
//     })

// }





export { appinitial, searchfromurl };

// export default appinitial


// WEBPACK FOOTER //
// ./src/axios/appinitial.js